





























import { unix as momunix } from 'moment'
import Vue, { PropType } from 'vue'
import { DateTimeService } from '../../../base/services/DateTimeService'
import { MessageChannel } from '../../../base/store/state.interface'
import { ChatService } from '../../../messenger/chat/ChatService'
import ChatNavigationView from '../../../messenger/ChatNavigationView.vue'
import { Widget } from '../base'
import { WidgetSettingsCustom } from '../base/widget/WidgetInterface'

import NoWidgetAccess from '../../components/NoWidgetAccess.vue'

export default Vue.extend({
  components: {
    ChatNavigationView,
    NoWidgetAccess
  },
  props: {
    widget: {
      required: true,
      type: Object as PropType<Widget>
    }
  },
  data() {
    return {
      userDidSelectChannel: false,
      activeChannel: null
    }
  },
  computed: {
    channels() {
      if (!this.widget.customSettings) {
        return
      }

      const widgetSettings = (this.widget.customSettings.settings.channel as WidgetSettingsCustom).data
      const channelCache = this.$store.state.message_channel.items as MessageChannel[]
      const channelMode = widgetSettings.channelMode || 0
      let result: any[] = []

      switch (channelMode) {
      // selected channels only?
      case '1':
        const channelIds = widgetSettings.channelIds

        if (!channelIds) {
          break
        }

        channelIds.forEach(channelId => {
          const channel = channelCache[channelId]
          if (!channel) {
            return
          }
          result.push(channel)
        })
        break
      default:
        result.push(...Object.values(channelCache))
        break
      }

      const messageCache = this.$store.state.message.items
      const consumerCache = this.$store.state.cluster.consumer

      // enrich channel information
      result.forEach(channel => {
        channel.numUnreadMessages = ChatService.getNumUnreadMessagesInChannel(channel)

        const message = messageCache[channel.last_message_id]

        if (!message) {
          return
        }

        const author = consumerCache[message.author_id]
        const authorInitials = (!author || !author.firstname || !author.lastname) ? '' : author.firstname.substring(0, 1) + author.lastname.substring(0, 1)

        const creationMoment = momunix(message.ts_create)
        let tsFormat = 'DD.MM.YYYY HH:mm'

        if (creationMoment.isSame(momunix(Date.now() / 1000), 'year')) {
          tsFormat = 'DD.MM. HH:mm'
        }

        if (creationMoment.isSame(momunix(Date.now() / 1000), 'day')) {
          tsFormat = 'HH:mm'
        }

        channel.messageTimestamp = DateTimeService.formatUnixTimestamp(message.ts_create, tsFormat)
        channel.lastMessage = (authorInitials ? authorInitials + ': ' : '') + (message ? message.text : '')
      })

      // when only 1 channel was selected in the backend, automatically jump into channel view
      if (!this.activeChannel || !this.userDidSelectChannel) {
        this.userDidSelectChannel = false
        this.activeChannel = (result.length === 1) ? result[0] : null
      }

      // show channels with unread messages only?
      if (widgetSettings.unreadMessagesOnly) {
        result = result.filter(channel => !!channel.numUnreadMessages)
      }

      return result
    }
  },
  methods: {
    async selectChannel(channel?: MessageChannel) {
      this.userDidSelectChannel = true
      this.activeChannel = channel
    }
  }
})
